module.exports = __webpack_public_path__ + "static/dec-event2.b4041270.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageDecEvent/images/dec-event2.jpg
// module id = 731
// module chunks = 89027509443936